module.exports = __webpack_public_path__ + "static/media/login.931967d6.svg";